export default __webpack_public_path__ + "static/media/Resume.6881a31f.pdf";